import {
  Select,
  SelectOption,
} from '../components/TovNativeSelect/TovNativeSelect';
import { useLocalization } from './LocalizationProvider';
import { SUPPORTED_LOCALES, type SupportedLocale } from './i18n';
import { getLanguageLabel } from './languages';

export function LocaleSwitcher({
  id,
  label = 'Language preference',
  className,
}: {
  id?: string;
  label?: string;
  className?: string;
}) {
  const { locale, setLocale } = useLocalization();

  return (
    <label className={className}>
      <span className="sr-only">{label}</span>
      <Select
        id={id}
        aria-label={label}
        value={locale}
        onChange={(event) => setLocale(event.target.value as SupportedLocale)}
      >
        {SUPPORTED_LOCALES.map((supportedLocale) => (
          <SelectOption key={supportedLocale} value={supportedLocale}>
            {getLanguageLabel(supportedLocale)}
          </SelectOption>
        ))}
      </Select>
    </label>
  );
}
